<template lang="pug">
v-navigation-drawer.z-50(v-model="showDrawer" mobile-breakpoint="xs" width="375" temporary right app)
  div
    KeepAlive(include="main")
      .px-6.d-flex.flex-column(v-if="page === 'main'")
        .d-flex.align-center.top-0.sticky.z-10.white.py-6
          .heading-5 {{ $t('add_filter') }}
          v-spacer
          .link-s(v-if="allFilters.length" @click="clearFilters") {{ $t('clear_all_filters') }}
        
        .mt-4
          v-sheet.round-xl.mb-4.border-dropdown(v-for="item in items" @click="openDetail(item.type)" :key="item.type" :class="getFilterData(item.type) ? 'border-selected' : ''" outlined)
            .d-flex.align-center.hover-bg.pa-4
              div
                .text-md.font-medium.text-none.neutral700--text Filter {{ item.name }}
                .text-sm.neutral500--text.mt-1(v-if="getFilterData(item.type)") {{ getFilterData(item.type) }}
              v-spacer
              v-menu(offset-y min-width=200 v-if="getFilterData(item.type)")
                template(v-slot:activator="{ on, attrs }")
                  v-btn(v-on="on" color="primary400" icon small)
                    v-icon mdi-dots-horizontal
                v-list.py-0
                  v-list-item(@click="openDetail(item.type)")
                    .text-sm Edit Filter
                  v-divider.basic300
                  v-list-item(@click="deleteFilter(item.type)")
                    .text-sm.danger500--text Delete Filter
              eva-icon(v-else name="arrow-ios-forward" fill="#888")
        
        .py-12
        .yc-fixed-bottom-section
          .px-3.py-2
            v-btn.button-md.white--text(@click="clickDone" color="info500" block depressed) {{ $t('done') }}

      filter-providers(v-else-if="page === 'providers'" :filter.sync="providersFilter" @onBack="back")
      filter-services(v-else-if="page === 'services'" :filter.sync="servicesFilter" @onBack="back")
      filter-payment(v-else-if="page === 'payment'" :filter.sync="paymentFilter" @onBack="back")
      filter-date(v-else-if="page === 'date'" :filter.sync="dateFilter" @onBack="back")
      filter-time(v-else-if="page === 'time'" :filter.sync="timeFilter" @onBack="back")
</template>

<script>
import FilterProviders from './FilterProviders.vue'
import FilterServices from './FilterServices.vue'
import FilterPayment from './FilterPayment.vue'
import FilterDate from './FilterDate.vue'
import FilterTime from './FilterTime.vue'

export default {
  props: ['open', 'filterData'],
  components: {
    FilterProviders,
    FilterServices,
    FilterPayment,
    FilterDate,
    FilterTime
  },
  data: () => ({
    page: 'main',
    providersFilter: {},
    servicesFilter: {},
    paymentFilter: {},
    dateFilter: {},
    timeFilter: {},
    items: [
      { name: 'Providers', type: 'providers' },
      { name: 'Services', type: 'services' },
      { name: 'Date', type: 'date' },
      { name: 'Time', type: 'time' },
      { name: 'Payment', type: 'payment' }
    ]
  }),
  computed: {
    showDrawer: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    allFilters () {
      const filters = []
      if (this.providersFilter?.items) {
        let list = this.providersFilter?.items.join(',')
        filters.push({ key: 'providers', value: list })
      }
      if (this.servicesFilter?.items) {
        let list = this.servicesFilter.items.join(',')
        filters.push({ key: 'services', value: list })
      }
      if (this.paymentFilter?.items) {
        let list = this.paymentFilter.items.join(',')
        filters.push({ key: 'paid', value: list })
      }
      if (this.dateFilter?.before) {
        filters.push({ key: 'date__lt', value: this.dateFilter.before })
      }
      if (this.dateFilter?.after) {
        filters.push({ key: 'date__gt', value: this.dateFilter.after })
      }
      if (this.dateFilter?.exact) {
        filters.push({ key: 'date', value: this.dateFilter.exact })
      }
      if (this.dateFilter?.between) {
        filters.push({ key: 'date__gte', value: this.dateFilter.between.start })
        filters.push({ key: 'date__lte', value: this.dateFilter.between.end })
      }
      if (this.timeFilter?.before) {
        filters.push({ key: 'time__lt', value: this.timeFilter.before })
      }
      if (this.timeFilter?.after) {
        filters.push({ key: 'time__gt', value: this.timeFilter.after })
      }
      if (this.timeFilter?.exact) {
        filters.push({ key: 'time', value: this.timeFilter.exact })
      }
      if (this.timeFilter?.between) {
        filters.push({ key: 'time__gte', value: this.timeFilter.between.start })
        filters.push({ key: 'time__lte', value: this.timeFilter.between.end })
      }
      return filters
    }
  },
  methods: {
    clearFilters () {
      this.providersFilter = {}
      this.servicesFilter = {}
      this.paymentFilter = {}
      this.dateFilter = {}
      this.timeFilter = {}
    },
    openDetail (page) {
      this.page = page
    },
    back () {
      this.page = 'main'
    },
    getFilterData (type) {
      switch (type) {
        case 'providers': {
          const length = this.providersFilter?.items?.length
          if (length) {
            return `${length} provider(s) selected`
          }
          break
        }
        case 'services': {
          const length = this.servicesFilter?.items?.length
          if (length) {
            return `${length} service(s) selected`
          }
          break
        }
        case 'payment': {
          const length = this.paymentFilter?.items?.length
          if (length) {
            return `${length} payment status(es) selected`
          }
          break
        }
        case 'date': {
          let changes = []
          for (const key in this.dateFilter) {
            const val = this.dateFilter[key]
            const name = this.getNameFromFilterKey(key)
            if (val) {
              if (key === 'between') {
                changes.push(`${name} ${val.start} - ${val.end}`)
              } else {
                changes.push(`${name} ${val} `)
              }
            }
          }
          return changes.join('\n')
        }
        case 'time': {
          let changes = []
          for (const key in this.timeFilter) {
            const val = this.timeFilter[key]
            const name = this.getNameFromFilterKey(key)
            if (val) {
              if (key === 'between') {
                const startTime = this.convert24to12(val.start)
                const endTime = this.convert24to12(val.end)
                changes.push(`${name} ${startTime} - ${endTime}`)
              } else {
                const time = this.convert24to12(val)
                changes.push(`${name} ${time} `)
              }
            }
          }
          return changes.join('\n')
        }
        default:
          return null
      }
    },
    getNameFromFilterKey (key){
      switch(key) {
        case 'exact':
          return 'Exact'
        case 'before':
          return 'Before'
        case 'after':
          return 'After'
        case 'between':
          return 'In between'
      }
      return key
    },
    deleteFilter (type) {
      switch (type) {
        case 'providers':
          this.providersFilter = {}
          break
        case 'services':
          this.servicesFilter = {}
          break
        case 'payment':
          this.paymentFilter = {}
          break
        case 'date':
          this.dateFilter = {}
          break
        case 'time':
          this.timeFilter = {}
          break
      }
    },
    clickDone () {
      this.$emit('done', this.allFilters)
      this.showDrawer = false
    },
    convert24to12 (timeString){
      var H = timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = (H < 12 || H === 24) ? "AM" : "PM";
      return `${h}${timeString.substr(2, 3)} ${ampm}`
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), 
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  box-shadow: unset !important;
}
.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
  max-height: 100% !important;
}
</style>